// extracted by mini-css-extract-plugin
export var icon = "_6j-1";
export var subtext = "_6j-0";